export default "data:image/gif;base64,R0lGODlhEgAMAPEAAAAAAP8AAP/XAAAAACH5BAAAAAAALAAAAAASAAwAAAIXhI+py+2vgpy02ouz3lb4D4biSJbmKRYAOw=="